// import React, { useState } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../config";

// function Payment({ userId, onPaymentSuccess, onCancel }) {
//   const [loading, setLoading] = useState(false);

//   const handlePayment = async () => {
//     setLoading(true);
//     try {
//       // Create order
//       const orderRes = await axios.post(`${API_BASE_URL}/create-order`, {
//         userId: userId,
//       });

//       const { orderId, amount, currency, keyId } = orderRes.data;

//       // Razorpay options
//       const options = {
//         key: keyId,
//         amount: amount,
//         currency: currency,
//         name: "File Transfer App",
//         description: "One-time Registration Fee",
//         order_id: orderId,
//         handler: async function (response) {
//           // Verify payment
//           try {
//             await axios.post(`${API_BASE_URL}/verify-payment`, {
//               userId: userId,
//               razorpay_order_id: response.razorpay_order_id,
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_signature: response.razorpay_signature,
//             });

//             alert("Payment successful! You can now login.");
//             if (onPaymentSuccess) onPaymentSuccess();
//           } catch (err) {
//             alert("Payment verification failed. Please contact support.");
//             console.error(err);
//           }
//         },
//         prefill: {
//           name: "",
//           email: "",
//           contact: "",
//         },
//         theme: {
//           color: "#1f2937",
//         },
//       };

//       const rzp = new window.Razorpay(options);
      
//       rzp.on("payment.failed", function (response) {
//         alert("Payment failed. Please try again.");
//         console.error(response.error);
//       });

//       rzp.open();
//       setLoading(false);
//     } catch (err) {
//       setLoading(false);
//       alert(err.response?.data?.error || "Failed to initiate payment");
//       console.error(err);
//     }
//   };

//   const styles = {
//     container: {
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       justifyContent: "center",
//       minHeight: "100vh",
//       backgroundColor: "#fafafa",
//       padding: "20px",
//     },
//     card: {
//       width: "400px",
//       backgroundColor: "#fff",
//       padding: "40px",
//       borderRadius: "16px",
//       boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
//       textAlign: "center",
//     },
//     icon: {
//       fontSize: "64px",
//       marginBottom: "20px",
//     },
//     heading: {
//       fontSize: "28px",
//       fontWeight: "700",
//       color: "#1f2937",
//       marginBottom: "12px",
//     },
//     price: {
//       fontSize: "48px",
//       fontWeight: "700",
//       color: "#1f2937",
//       marginBottom: "8px",
//     },
//     description: {
//       fontSize: "15px",
//       color: "#6b7280",
//       marginBottom: "30px",
//       lineHeight: "1.6",
//     },
//     button: {
//       width: "100%",
//       height: "50px",
//       backgroundColor: "#1f2937",
//       borderRadius: "10px",
//       color: "#fff",
//       fontSize: "16px",
//       fontWeight: "600",
//       border: "none",
//       cursor: "pointer",
//       marginBottom: "12px",
//       transition: "background-color 0.3s",
//     },
//     buttonDisabled: {
//       backgroundColor: "#9ca3af",
//       cursor: "not-allowed",
//     },
//     cancelButton: {
//       width: "100%",
//       height: "50px",
//       backgroundColor: "transparent",
//       borderRadius: "10px",
//       color: "#6b7280",
//       fontSize: "16px",
//       fontWeight: "600",
//       border: "1px solid #e5e7eb",
//       cursor: "pointer",
//       transition: "all 0.3s",
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.card}>
//         <div style={styles.icon}>💳</div>
//         <h2 style={styles.heading}>Complete Your Registration</h2>
//         <div style={styles.price}>₹500</div>
//         <p style={styles.description}>
//           One-time registration fee to activate your account and start transferring files securely.
//         </p>
//         <button
//           style={{
//             ...styles.button,
//             ...(loading ? styles.buttonDisabled : {}),
//           }}
//           onClick={handlePayment}
//           disabled={loading}
//         >
//           {loading ? "Processing..." : "Pay Now"}
//         </button>
//         <button style={styles.cancelButton} onClick={onCancel}>
//           Cancel
//         </button>
//       </div>
//     </div>
//   );
// }

// export default Payment;



import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";
import { FaCreditCard } from "@react-icons/all-files/fa/FaCreditCard";
import { FaLock } from "@react-icons/all-files/fa/FaLock";
import { FaCheckCircle } from "@react-icons/all-files/fa/FaCheckCircle";
import { FaShieldAlt } from "@react-icons/all-files/fa/FaShieldAlt";
import { FaTimes } from "@react-icons/all-files/fa/FaTimes";

function Payment({ userId, onPaymentSuccess, onCancel }) {
  const [loading, setLoading] = useState(false);

  const handlePayment = async () => {
    setLoading(true);
    try {
      const orderRes = await axios.post(`${API_BASE_URL}/create-order`, {
        userId: userId,
      });

      const { orderId, amount, currency, keyId } = orderRes.data;

      const options = {
        key: keyId,
        amount: amount,
        currency: currency,
        name: "File Transfer App",
        description: "One-time Registration Fee",
        order_id: orderId,
        handler: async function (response) {
          try {
            await axios.post(`${API_BASE_URL}/verify-payment`, {
              userId: userId,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });

            alert("Payment successful! You can now login.");
            if (onPaymentSuccess) onPaymentSuccess();
          } catch (err) {
            alert("Payment verification failed. Please contact support.");
            console.error(err);
          }
        },
        prefill: {
          name: "",
          email: "",
          contact: "",
        },
        theme: {
          color: "#1f2937",
        },
      };

      const rzp = new window.Razorpay(options);
      
      rzp.on("payment.failed", function (response) {
        alert("Payment failed. Please try again.");
        console.error(response.error);
      });

      rzp.open();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      alert(err.response?.data?.error || "Failed to initiate payment");
      console.error(err);
    }
  };

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",

      padding: "20px",
    },
    card: {
      width: "100%",
      maxWidth: "480px",
      backgroundColor: "#fff",
      padding: "0",
      borderRadius: "20px",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
      overflow: "hidden",
    },
    header: {
      background: "gray",
      padding: "40px 30px",
      textAlign: "center",
      position: "relative",
    },
    closeButton: {
      position: "absolute",
      top: "15px",
      right: "15px",
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      border: "none",
      color: "#fff",
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "16px",
      transition: "all 0.3s",
    },
    iconContainer: {
      width: "80px",
      height: "80px",
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto 20px",
      backdropFilter: "blur(10px)",
    },
    icon: {
      fontSize: "40px",
      color: "#fff",
    },
    heading: {
      fontSize: "28px",
      fontWeight: "700",
      color: "#fff",
      marginBottom: "8px",
    },
    subheading: {
      fontSize: "15px",
      color: "rgba(255, 255, 255, 0.9)",
      fontWeight: "400",
    },
    body: {
      padding: "40px 30px",
    },
    priceContainer: {
      textAlign: "center",
      marginBottom: "30px",
      padding: "20px",
      backgroundColor: "#f8f9fa",
      borderRadius: "12px",
      border: "2px solid #e9ecef",
    },
    priceLabel: {
      fontSize: "14px",
      color: "#6b7280",
      marginBottom: "8px",
      fontWeight: "600",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    price: {
      fontSize: "48px",
      fontWeight: "700",
      color: "#1f2937",
      marginBottom: "4px",
    },
    priceDescription: {
      fontSize: "13px",
      color: "#9ca3af",
    },
    features: {
      marginBottom: "30px",
    },
    feature: {
      display: "flex",
      alignItems: "center",
      marginBottom: "16px",
    },
    featureIcon: {
      width: "40px",
      height: "40px",
      backgroundColor: "#e0e7ff",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "15px",
      fontSize: "18px",
      color: "#667eea",
    },
    featureText: {
      fontSize: "15px",
      color: "#374151",
      fontWeight: "500",
    },
    button: {
      width: "100%",
      height: "54px",
      background: "black",
      borderRadius: "12px",
      color: "#fff",
      fontSize: "16px",
      fontWeight: "600",
      border: "none",
      cursor: "pointer",
      marginBottom: "12px",
      transition: "all 0.3s",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
    },
    buttonDisabled: {
      background: "#9ca3af",
      cursor: "not-allowed",
      boxShadow: "none",
    },
    cancelButton: {
      width: "100%",
      height: "50px",
      backgroundColor: "transparent",
      borderRadius: "10px",
      color: "#6b7280",
      fontSize: "15px",
      fontWeight: "600",
      border: "2px solid #e5e7eb",
      cursor: "pointer",
      transition: "all 0.3s",
    },
    securityNote: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
      marginTop: "20px",
      fontSize: "13px",
      color: "#9ca3af",
    },
    securityIcon: {
      fontSize: "16px",
      color: "#10b981",
    },
  };

  return (
    <>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @media (max-width: 768px) {
            .payment-card {
              max-width: 100% !important;
              border-radius: 0 !important;
            }
            
            .payment-header {
              padding: 30px 20px !important;
            }
            
            .payment-body {
              padding: 30px 20px !important;
            }
            
            .payment-heading {
              font-size: 24px !important;
            }
            
            .payment-price {
              font-size: 40px !important;
            }
          }

          @media (max-width: 480px) {
            .payment-container {
              padding: 0 !important;
            }
            
            .payment-price {
              font-size: 36px !important;
            }
            
            .icon-container {
              width: 70px !important;
              height: 70px !important;
            }
            
            .payment-icon {
              font-size: 32px !important;
            }
          }

          .payment-button:hover:not(:disabled) {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
          }

          .cancel-button:hover {
            background-color: #f3f4f6;
            border-color: #d1d5db;
          }

          .close-button:hover {
            background-color: rgba(255, 255, 255, 0.3);
          }
        `}
      </style>
      <div className="payment-container" style={styles.container}>
        <div className="payment-card" style={styles.card}>
          {/* Header */}
          <div className="payment-header" style={styles.header}>
            <button 
              className="close-button"
              style={styles.closeButton} 
              onClick={onCancel}
            >
              <FaTimes />
            </button>
            <div className="icon-container" style={styles.iconContainer}>
              <FaCreditCard style={styles.icon} className="payment-icon" />
            </div>
            <h2 className="payment-heading" style={styles.heading}>Complete Your Registration</h2>
            <p style={styles.subheading}>Secure your account access today</p>
          </div>

          {/* Body */}
          <div className="payment-body" style={styles.body}>
            {/* Price */}
            <div style={styles.priceContainer}>
              <div style={styles.priceLabel}>One-Time Payment</div>
              <div className="payment-price" style={styles.price}>₹500</div>
              <div style={styles.priceDescription}>Lifetime access • No recurring fees</div>
            </div>

            {/* Features */}
            <div style={styles.features}>
              <div style={styles.feature}>
                <div style={styles.featureIcon}>
                  <FaCheckCircle />
                </div>
                <div style={styles.featureText}>Unlimited file transfers</div>
              </div>
              <div style={styles.feature}>
                <div style={styles.featureIcon}>
                  <FaShieldAlt />
                </div>
                <div style={styles.featureText}>Secure & encrypted transfers</div>
              </div>
              <div style={styles.feature}>
                <div style={styles.featureIcon}>
                  <FaLock />
                </div>
                <div style={styles.featureText}>Priority customer support</div>
              </div>
            </div>

            {/* Buttons */}
            <button
              className="payment-button"
              style={{
                ...styles.button,
                ...(loading ? styles.buttonDisabled : {}),
              }}
              onClick={handlePayment}
              disabled={loading}
            >
              {loading ? (
                <>⏳ Processing...</>
              ) : (
                <>
                  <FaLock /> Proceed to Secure Payment
                </>
              )}
            </button>
            
            <button 
              className="cancel-button"
              style={styles.cancelButton} 
              onClick={onCancel}
            >
              Maybe Later
            </button>

            {/* Security Note */}
            <div style={styles.securityNote}>
              <FaShieldAlt style={styles.securityIcon} />
              <span>Secured by Razorpay</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Payment;
